
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_744_19649)"}},[_c('path',{attrs:{"d":"M8.5 16a8 8 0 100-16.001A8 8 0 008.5 16z","fill":"#FBD6D6"}}),_c('path',{attrs:{"d":"M5.969 5.468a.747.747 0 011.06 0l1.468 1.47 1.469-1.47a.75.75 0 011.06 1.06l-1.47 1.468 1.47 1.47a.75.75 0 01-1.06 1.06l-1.469-1.47-1.469 1.469a.75.75 0 01-1.06-1.06l1.47-1.469-1.47-1.468a.747.747 0 010-1.06z","fill":"red"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_744_19649"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    